// extracted by mini-css-extract-plugin
export var modalFooter = "_qs-0";